/**
 * Okendo Review ADA compatibility fixes
 * This script adds alt text to product images in Okendo reviews
 * Enhanced with retry mechanism and improved detection
 */

document.addEventListener('DOMContentLoaded', function() {
  // Initial attempt to fix alt text
  setTimeout(() => {
    fixOkendoReviewImageAltText();
    
    // Set up retry mechanism for Okendo content that loads later
    setupRetryMechanism();
    
    // Set up observer to catch dynamically loaded Okendo content
    setupMutationObserver();
  }, 500); // Small delay to allow for initial rendering
});

/**
 * Set up retry mechanism to handle delayed Okendo content loading
 */
function setupRetryMechanism() {
  let retryCount = 0;
  const maxRetries = 5;
  const retryInterval = 1000; // 1 second between retries
  
  const retryTimer = setInterval(() => {
    // Check if there are any Okendo images without alt text
    const okendoImages = document.querySelectorAll('.oke-product-thumbnail-image');
    const imagesWithoutAlt = Array.from(okendoImages).filter(img => !img.alt || img.alt === '');
    
    if (imagesWithoutAlt.length > 0) {
      fixOkendoReviewImageAltText();
    }
    
    retryCount++;
    
    // Also check for any Okendo containers that might be loaded but images not yet processed
    const okendoContainers = document.querySelectorAll('.okendo-reviews-widget, .oke-reviews');
    if (okendoContainers.length > 0) {
      fixOkendoReviewImageAltText();
    }
    
    // Stop retrying after max attempts
    if (retryCount >= maxRetries) {
      clearInterval(retryTimer);
      
      // One final check for any images that might have loaded late
      setTimeout(fixOkendoReviewImageAltText, 2000);
    }
  }, retryInterval);
}

/**
 * Add alt text to Okendo review product images
 */
function fixOkendoReviewImageAltText() {
  // Target all Okendo product thumbnail images with various selectors to ensure we catch them all
  const selectors = [
    '.oke-product-thumbnail-image[alt=""]', 
    '.oke-product-thumbnail-image:not([alt])',
    '.oke-review img[alt=""]',
    '.oke-review img:not([alt])',
    '.okendo-reviews-widget img[alt=""]',
    '.okendo-reviews-widget img:not([alt])'
  ];
  
  const okendoImages = document.querySelectorAll(selectors.join(', '));
  
  okendoImages.forEach(image => {
    // Skip images that already have a non-empty alt text
    if (image.hasAttribute('alt') && image.getAttribute('alt').trim() !== '') {
      return;
    }
    
    // Get product name from context if available
    let productName = "Clean Skin Club product";
    
    // Try to find product name from nearby elements with multiple possible selectors
    const reviewContainer = image.closest('.oke-review') || image.closest('[class*="oke-"]');
    if (reviewContainer) {
      // Try multiple possible selectors for product title
      const productTitleSelectors = [
        '.oke-product-title',
        '.oke-product-name',
        '.oke-review-product-name',
        '[class*="product-title"]',
        '[class*="product-name"]'
      ];
      
      let productTitle = null;
      for (const selector of productTitleSelectors) {
        productTitle = reviewContainer.querySelector(selector);
        if (productTitle && productTitle.textContent) {
          productName = productTitle.textContent.trim();
          break;
        }
      }
      
      // If we still don't have a product name, try to get it from the page context
      if (productName === "Clean Skin Club product") {
        const pageProductTitle = document.querySelector('.product__title, h1.product-single__title, .product-single__title h1');
        if (pageProductTitle && pageProductTitle.textContent) {
          productName = pageProductTitle.textContent.trim();
        }
      }
    }
    
    // Set descriptive alt text
    image.setAttribute('alt', `Product image: ${productName}`);
    
    // Also ensure role is appropriate (if it exists)
    if (image.hasAttribute('role')) {
      image.setAttribute('role', 'img');
    }
  });
}

/**
 * Set up MutationObserver to watch for dynamically added Okendo elements
 */
function setupMutationObserver() {
  // Create a new observer
  const observer = new MutationObserver(mutations => {
    let hasNewContent = false;
    
    mutations.forEach(mutation => {
      // Check for attribute changes on existing images
      if (mutation.type === 'attributes' && 
          mutation.attributeName === 'src' && 
          mutation.target.nodeName === 'IMG') {
        const img = mutation.target;
        if (!img.alt || img.alt === '') {
          hasNewContent = true;
        }
      }
      
      // Check for new nodes
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        // Check each added node
        mutation.addedNodes.forEach(node => {
          // Check if the node is an element
          if (node.nodeType === 1) {
            // Check if it's an Okendo-related element or contains images
            if (node.classList && 
                (node.classList.contains('oke-review') || 
                 node.classList.contains('okendo-reviews-widget') ||
                 node.querySelector('img'))) {
              hasNewContent = true;
            }
          }
        });
      }
    });
    
    // If new content was detected, fix alt text
    if (hasNewContent) {
      // Small delay to ensure content is fully rendered
      setTimeout(fixOkendoReviewImageAltText, 100);
    }
  });
  
  // Start observing the document body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src', 'alt'],
    characterData: false
  });
}